import {Filter} from "@/models/frontend/FeatureModels";
import {ListingSearchCriteria} from "@/models/backend/ListingModels";
import {CustomerType} from "@/models/backend/CustomerModels";

/**
 * Transform frontend filters into backend-compatible search criteria.
 * @param filters - Array of Filter objects from the frontend.
 * @returns ListingSearchCriteria - Backend-compatible search criteria.
 */
export function transformFiltersToSearchCriteria(filters: Filter[]): ListingSearchCriteria {
    const searchCriteria: ListingSearchCriteria = {
        filters: {},
        pagination: { limit: "100", offset: "0" }
    };

    filters.forEach((filter) => {

        if(filter.id.startsWith("feature-")) {
            if (filter.value && Array.isArray(filter.value) && filter.value.length > 0) {
                searchCriteria.filters!.featureValueIds = [
                    ...(searchCriteria.filters!.featureValueIds || []),
                    ...filter.value.map((value) => value.toString()),
                ];
            }

        } else {
            switch (filter.id) {


                case "pcode": // Postal Code
                    if (filter.value) {
                        searchCriteria.filters!.location = {
                            postalCode: filter.value as string,
                            rangeInKm: searchCriteria.filters!.location?.rangeInKm?.toString(), // Preserve range if set
                        };
                    }
                    break;
                case "entity": // Postal Code
                    if (filter.value) {
                        searchCriteria.filters!.customerTypes = filter.value as CustomerType[];
                    }
                    break;

                case "distance": // Distance
                    if (filter.value !== null) {
                        searchCriteria.filters!.location = {
                            ...searchCriteria.filters!.location,
                            rangeInKm: String(filter.value).toString(),
                        };
                    }
                    break;

                case "type": // Listing Type
                    if ((filter.value as any[]).length > 0) {
                        searchCriteria.filters!.type = (filter.value as any[])[0].toString();
                    }
                    break;

                case "price": // Price
                    if (filter.value !== null) {
                        searchCriteria.filters!.price = String(filter.value);
                    }
                    break;

                case "quantity": // Quantity
                    if (filter.value !== null) {
                        searchCriteria.filters!.quantity = String(filter.value);
                    }
                    break;

                case "shipmentMethod": // Shipment Method
                    if ((filter.value as any[]).length > 0) {
                        searchCriteria.filters!.shippingAvailable = (filter.value as any[]).includes(1)
                            ? "true"
                            : undefined;
                        searchCriteria.filters!.pickupAvailable = (filter.value as any[]).includes(2)
                            ? "true"
                            : undefined;
                    }
                    break;

                case "availableDate": // Availability Date
                    if (filter.value) {
                        searchCriteria.filters!.availableDate = {
                            to: filter.value as string,
                        };
                    }
                    break;

                default:
                    // Handle additional cases as necessary
                    break;
            }
        }


    });

    return searchCriteria;
}

